export default "__VITE_ASSET__7740510e__"